/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: fRuRbcdHVNMtdcnFK96ivt
// Component: 4cC-CjBM0Irp
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  renderPlasmicSlot,
  useCurrentUser,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import ButtonActionPictogram from "../../ButtonActionPictogram"; // plasmic-import: NdapmL4tQ5kp/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/projectcss
import sty from "./PlasmicPartnerAvatarPannelPlaceholder.module.css"; // plasmic-import: 4cC-CjBM0Irp/css
import image8KTo8Rg8U39Nh from "./images/image8.svg"; // plasmic-import: KTo8rg8u39NH/picture

createPlasmicElementProxy;

export const PlasmicPartnerAvatarPannelPlaceholder__VariantProps = new Array(
  "isVisible"
);

export const PlasmicPartnerAvatarPannelPlaceholder__ArgProps = new Array(
  "actionsWrapp2"
);

const $$ = {};

function PlasmicPartnerAvatarPannelPlaceholder__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = useCurrentUser?.() || {};
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "isVisible",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.isVisible
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.root,
        { [sty.rootisVisible]: hasVariant($state, "isVisible", "isVisible") }
      )}
    >
      <div className={classNames(projectcss.all, sty.freeBox__pi03J)}>
        <div
          className={classNames(projectcss.all, sty.freeBox___2RxTu, {
            [sty.freeBoxisVisible___2RxTuxffkf]: hasVariant(
              $state,
              "isVisible",
              "isVisible"
            )
          })}
        >
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text___3HmDc
            )}
          >
            {"John Doe"}
          </div>
          <div
            data-plasmic-name={"actionsWrapp"}
            data-plasmic-override={overrides.actionsWrapp}
            className={classNames(projectcss.all, sty.actionsWrapp, {
              [sty.actionsWrappisVisible]: hasVariant(
                $state,
                "isVisible",
                "isVisible"
              )
            })}
          >
            {renderPlasmicSlot({
              defaultContents: (
                <ButtonActionPictogram
                  className={classNames(
                    "__wab_instance",
                    sty.buttonActionPictogram__lXUua
                  )}
                  color={"greyTwo"}
                  iconActionButton={
                    <PlasmicImg__
                      alt={""}
                      className={classNames(sty.img__jihXu)}
                      displayHeight={"100%"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"none"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"100%"}
                      loading={"lazy"}
                      src={{
                        src: image8KTo8Rg8U39Nh,
                        fullWidth: 20,
                        fullHeight: 20,
                        aspectRatio: undefined
                      }}
                    />
                  }
                  size={"medium"}
                  status={"normal"}
                />
              ),

              value: args.actionsWrapp2
            })}
          </div>
        </div>
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text___2ENi,
            {
              [sty.textisVisible___2ENixffkf]: hasVariant(
                $state,
                "isVisible",
                "isVisible"
              )
            }
          )}
        >
          {"Bio."}
        </div>
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__hTjkN,
            {
              [sty.textisVisible__hTjkNxffkf]: hasVariant(
                $state,
                "isVisible",
                "isVisible"
              )
            }
          )}
        >
          {"[ link ]"}
        </div>
      </div>
      <div
        className={classNames(
          projectcss.all,
          projectcss.__wab_text,
          sty.text___63H2B,
          {
            [sty.textisVisible___63H2Bxffkf]: hasVariant(
              $state,
              "isVisible",
              "isVisible"
            )
          }
        )}
      >
        {"Description."}
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: ["root", "actionsWrapp"],
  actionsWrapp: ["actionsWrapp"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicPartnerAvatarPannelPlaceholder__ArgProps,
          internalVariantPropNames:
            PlasmicPartnerAvatarPannelPlaceholder__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicPartnerAvatarPannelPlaceholder__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicPartnerAvatarPannelPlaceholder";
  } else {
    func.displayName = `PlasmicPartnerAvatarPannelPlaceholder.${nodeName}`;
  }
  return func;
}

export const PlasmicPartnerAvatarPannelPlaceholder = Object.assign(
  // Top-level PlasmicPartnerAvatarPannelPlaceholder renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    actionsWrapp: makeNodeComponent("actionsWrapp"),
    // Metadata about props expected for PlasmicPartnerAvatarPannelPlaceholder
    internalVariantProps: PlasmicPartnerAvatarPannelPlaceholder__VariantProps,
    internalArgProps: PlasmicPartnerAvatarPannelPlaceholder__ArgProps
  }
);

export default PlasmicPartnerAvatarPannelPlaceholder;
/* prettier-ignore-end */
